import mapboxgl from 'mapbox-gl/dist/mapbox-gl-csp';
import 'mapbox-gl/dist/mapbox-gl.css';

const publicUrl = process.env.PUBLIC_URL || '';

mapboxgl.accessToken = 'pk.eyJ1IjoiamFja3k0NTY2IiwiYSI6ImNrdm54ODFqcGUzOWsycXE2Y2YxZXR3MDIifQ.pJwfydUY9qaUrkCb2NKxyA';
mapboxgl.workerUrl = `${publicUrl}/mapbox-gl-csp-worker.js`;

export default mapboxgl;
